if (!window.Eurus.loadedScript.has('product-popup-bundle.js')) {
  window.Eurus.loadedScript.add('product-popup-bundle.js');

  window.BYOBState = {
    steps: [],
    totalSteps: 0
  };

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data('byobPopup', () => ({
        isOpen: false,
        popupData: {},
        currentStep: null,
        parentEl: null,

        openPopup(data, stepIndex, parentEl) {
          this.popupData = data;
          this.isOpen = true;
          this.currentStep = stepIndex;
          this.parentEl = parentEl;

          if (!window.BYOBState.steps.find(s => s.index === stepIndex)) {
            window.BYOBState.steps.push({ index: stepIndex, stepComplete: false });
          }
        },

        closePopup() {
          this.isOpen = false;
          this.popupData = {};
          this.currentStep = null;

          if (this.parentEl) {
            this.parentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.parentEl = null;
          }
        },

        initByob(totalSteps) {
          window.BYOBState.totalSteps = totalSteps;
          if (!window.BYOBState.steps.length) {
            window.BYOBState.steps = Array.from({ length: totalSteps }, (_, i) => ({
              index: i,
              stepComplete: false
            }));
          }
        },

        productRating(rating) {
          return {
            star_fill: parseInt(rating?.star_fill) || 0,
            star_half: parseInt(rating?.star_half) || 0,
            star_empty: parseInt(rating?.star_empty) || 0,
            rating_count: parseInt(rating?.rating_count) || 0
          };
        },

        addVariantToCart(variantId, stepIndex, quantity = 1) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
          })
            .then(res => res.json())
            .then(() => {
              if (stepIndex !== null) {
                const step = window.BYOBState.steps.find(s => s.index === stepIndex);
                if (step) step.stepComplete = true;
              }

              const bubble = document.querySelector('#cart-icon-bubble > div');
              const bubbleSpan = bubble?.querySelector('span');
              if (bubble && bubbleSpan) {
                bubble.classList.remove('hidden');
                const currentCount = parseInt(bubbleSpan.textContent) || 0;
                bubbleSpan.textContent = currentCount + quantity;
              }

              this.closePopup();

              if (window.BYOBState.steps.every(s => s.stepComplete)) {
                window.location.href = '/cart';
              }
            })
            .catch(err => console.error(err));
        }
      }));
    });
  });
}
